import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
	beforeLoad: ({ context }) => {
		if (context.isAuthenticated) {
			throw redirect({ to: "/home", replace: true })
		}
		throw redirect({ to: "/onboarding", replace: true })
	},
})
